module.exports = "/_next/static/images/check-on-client-cf885b0d.png";